import { Action } from '@ngrx/store';

export class ActionTypes {
  static CLEAR_STATE = '[App] logout';
}

export class CLEAR_STATE implements Action {
  readonly type = ActionTypes.CLEAR_STATE;
}

export function clearState(reducer) {
  return function (state, action) {
    if (action.type === ActionTypes.CLEAR_STATE) {
      // "clear" the state by just reassigning it to user and uiStyle
      state = { user: state.user, uiStyle: state.uiStyle };
    }

    return reducer(state, action);
  };
}
